import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Checkbox } from '@/components/ui/checkbox'
import { Button } from '@/components/ui/button'
import { Plus, Minus } from 'lucide-react'

interface DocumentationFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function DocumentationForm({ form, isView }: DocumentationFormProps) {
  const [witnesses, setWitnesses] = useState<string[]>([''])

  const addWitness = () => {
    setWitnesses([...witnesses, ''])
  }

  const removeWitness = (index: number) => {
    if (witnesses.length > 1) {
      const newWitnesses = witnesses.filter((_, i) => i !== index)
      setWitnesses(newWitnesses)
      form.setValue('Witness', newWitnesses)
    }
  }

  const updateWitness = (index: number, value: string) => {
    const newWitnesses = [...witnesses]
    newWitnesses[index] = value
    setWitnesses(newWitnesses)
    form.setValue('Witness', newWitnesses)
  }

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="Nature Of Instrument"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nature of Instrument *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter nature of instrument" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <FormLabel>Witness/es *</FormLabel>
          {!isView && (
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={addWitness}
              className="h-8"
            >
              <Plus className="h-4 w-4 mr-1" />
              Add Witness
            </Button>
          )}
        </div>

        {witnesses.map((witness, index) => (
          <div key={index} className="flex gap-2">
            <Input
              value={witness}
              onChange={(e) => updateWitness(index, e.target.value)}
              disabled={isView}
              placeholder={`Witness ${index + 1}`}
              required
              className="flex-1"
            />
            {!isView && witnesses.length > 1 && (
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => removeWitness(index)}
                className="h-10 w-10 p-0"
              >
                <Minus className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
      </div>

      <FormField
        control={form.control}
        name="Copy"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={isView}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                Copy to <span className="text-accent">Oaths Administered</span>
              </FormLabel>
            </div>
          </FormItem>
        )}
      />
    </div>
  )
}
